/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import PerformanceFlag from './index';
const meta = {
    title: 'Features/IIMReview/PerformanceFlag',
    component: PerformanceFlag,
    parameters: { layout: 'padded' },
    decorators: [
        (Story) => (React.createElement("div", { style: { maxWidth: 720 } },
            React.createElement(Story, null)))
    ]
};
export default meta;
export const RecurringDeficiency = {
    args: {
        icon: 'fa-triangle-exclamation',
        title: 'Recurring Deficiency Pattern',
        description: '"Fire extinguisher missing inspection tag" flagged 5 times since January 2026 — every deficiency still open, no repair documented',
        meta: 'Oldest occurrence: 231 days ago • Asset: Riser A'
    }
};
export const DocumentationGaps = {
    args: {
        icon: 'fa-file-lines',
        title: 'Documentation Gaps',
        description: '12 unanswered questions in 3 sections and 2 deficiencies missing their notes and photos',
        meta: 'Last occurrence: this inspection • Asset: Fire Pump 1'
    }
};
export const AssetCountChange = {
    args: {
        icon: 'fa-building',
        title: 'Asset Count Change',
        description: 'Asset count went 12 to 4 since 05-28-2026'
    }
};
export const NoMeta = {
    args: {
        icon: 'fa-circle-info',
        title: 'Flag without a meta line',
        description: 'The meta line is optional and omitted when there is nothing to show.'
    }
};
export const LongText = {
    args: {
        icon: 'fa-triangle-exclamation',
        title: 'Recurring Deficiency Pattern',
        description: '"Sprinkler head painted over or obstructed by storage within eighteen inches of the deflector in the east mechanical room and adjacent corridor" flagged 14 times since September 2025 — 9 of 14 still open',
        meta: 'Oldest occurrence: 402 days ago • Asset: Wet Pipe Sprinkler System — Building B, Level 2, East Mechanical Room'
    }
};
